<template>
  <div class="eventComp_mode_13 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 对抗类 单人列表表格 （武术 对抗类 A -- 武术 男子70公斤级）（柔道 对抗类 A -- 柔道 男子-100公斤级）（普通表格）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_13',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //数据的类型 A || D || T,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_13 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_13',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 39.3,
      tableCellDefaultWidthVw: 11.1,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      renderModeList: [
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['WSU'],
          isTabType: 'startList',
        },
        {
          modeName: '',
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['WSU'],
          isTabType: 'localData',
        },
        {
          modeName: '',
          tableCellDefaultWidthVw: 6.94,
          variableColWidthVw: [],
          sportsIdArr: ['JUD'],
          isTabType: 'localData',
        },
      ],
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isTabType) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isTabType === this.tabType
              ) {
                this.currModeObj = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }
        console.debug(this.currModeObj, this.datas, this.currSportsDetail)
        if (this.currModeObj.datasChildKey) {
          this.computedModeData(
            JSON.parse(
              JSON.stringify(this.datas[this.currModeObj.datasChildKey])
            )
          )
        } else {
          this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
        }
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data && data.table_head) {
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let customColumn = null
          let competitorType = this.competitorType
          if (competitorType === 'A') {
            customColumn = {
              prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
              label: '运动员',
              // widthVw:
              //   this.currModeObj.variableColWidthVw[
              //     this.currModeObj.sportsIdArr.indexOf(
              //       this.currSportsDetail.sportsId
              //     )
              //   ], //对应列的宽度，单位vw
              className: 'columnPlayerGroupClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }
          } else if (competitorType === 'D') {
            customColumn = {
              prop: 'teamLogo-playerListString', //fristColumnPropArr.join('-'),
              label: '国家/地区',
              // widthVw:
              //   this.currModeObj.variableColWidthVw[
              //     this.currModeObj.sportsIdArr.indexOf(
              //       this.currSportsDetail.sportsId
              //     )
              //   ], //对应列的宽度，单位vw
              className: 'columnPlayerGroupClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }
          }

          if (this.currModeObj.tableCellDefaultWidthVw) {
            this.tableCellDefaultWidthVw =
              this.currModeObj.tableCellDefaultWidthVw
          }
          let widthVw = this.tableCellDefaultWidthVw

          let flag = false
          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
              // 特殊列
              if (!flag) {
                // 只插入一次，其他不插入，但要把这次的column过滤掉
                tableColumnData.push(customColumn)
              }
              flag = true
            } else {
              // 普通列
              tableColumnData.push({
                prop: item.colKey,
                label: item.colTitle,
                // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? this.tableCellDefaultWidthVw / 2
                //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? 'expandTdClassName'
                //   : '', //单独定制的头部样式class
                widthVw,
                className: '',
                selected: '',
              })
            }
          }
          this.defaultWidthVwNum = tableColumnData.length - 1 //减去这1列[运动员]
          this.tableColumnData = tableColumnData
          console.debug('tableColumnData:', tableColumnData)
        }
        let tableData = [],
          keyArr = ['home', 'away']
        if (this.currModeObj.isTabType === 'startList') {
          keyArr.forEach((key) => {
            tableData.push(data[key])
          })
        } else if (this.currModeObj.isTabType === 'localData') {
          keyArr.forEach((key) => {
            tableData = [].concat(tableData, data[key])
          })
          tableData.forEach((rowData) => {
            if (rowData.is_win === false) {
              rowData.is_win = '负'
            }
            if (rowData.is_win === true) {
              rowData.is_win = '胜'
            }
            if (
              rowData.players &&
              rowData.players.length > 0 &&
              this.competitorType === 'A'
            ) {
              const playerItem = rowData.players[0]
              rowData.player_name = playerItem.player_name
              rowData.player_id = playerItem.player_id
              rowData.player_logo = playerItem.player_logo
              rowData.player_gender = playerItem.player_gender
            }
          })
        }
        this.tableData = tableData
        this.tableTotal = tableData.length
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
